import { Redirect } from "react-router-dom";
const Protected = ({ permissions, children }) => {
    const { role } = JSON.parse(localStorage.getItem("user_info")) || -1
    if (!permissions.includes(role)) {
        return <Redirect to="/" />
    }
    return children;
};
export default Protected